import { api } from '../utils/api';
import type { DashboardSummary } from '../types/@types/dashboard';

export async function getDashboardSummary(): Promise<DashboardSummary> {
  const { data } = await api.get<DashboardSummary>('/dashboard/summary');
  return data;
}

// ── Realtime dashboard ────────────────────────────────────────────────────────

export interface RealtimeToday {
  totalRevenue: number;
  totalOrders: number;
  avgTicket: number;
  activeOrders: number;
  occupiedTables: number;
  totalTables: number;
}

export interface HourlySlot {
  hour: number;
  label: string;
  orders: number;
  revenue: number;
}

export interface RecentOrder {
  id: number;
  customerName?: string;
  tableName?: string;
  total: number;
  paymentStatus: string;
  status: string;
  fulfillmentType?: string;
  createdAt: string;
}

export interface TopProduct {
  name: string;
  qty: number;
}

export interface RealtimeDashboard {
  generatedAt: string;
  today: RealtimeToday;
  hourly: HourlySlot[];
  recentOrders: RecentOrder[];
  topProducts: TopProduct[];
}

export async function getRealtimeDashboard(): Promise<RealtimeDashboard> {
  const { data } = await api.get<RealtimeDashboard>('/dashboard/realtime');
  return data;
}
